module.exports = __webpack_public_path__ + "vue-assets/img/Osborne_clarke.7b9284c5.png";